<template>
	<DjBox class="relative pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium">{{ title }}</h3>
		<div
			class="content-rte mt-4 border-l-4 border-dj-red pl-3 py-1 italic font-zillaslab text-2xl text-dj-grey-dark font-light break-words"
			v-html="text"
		></div>
		<div class="flex mt-5 items-center justify-start">
			<BaseCloudImage
				class="min-w-[60px] border-1 border-dj-red rounded-full overflow-hidden"
				:public-id="authorPhotoId"
				:alt="author || title"
				postfix=".jpg"
				:transformation="[{ width: 60, height: 60, crop: 'scale' }]"
			/>
			<div class="ml-5">
				<p class="text-base font-medium">{{ author }}</p>
				<p class="text-sm mt-1 text-dj-grey-dark font-light">{{ authorTitle }}</p>
			</div>
		</div>
		<BaseIcon
			class="absolute bottom-20 md:bottom-24 right-5 md:right-10 opacity-25 z-0"
			color="#CDD2E1"
			:width="120"
			:height="120"
			icon="bxs:quote-alt-right"
		/>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DjBox from "./DjBox.vue";
import BaseCloudImage from "../BaseCloudImage.vue";
import BaseIcon from "../BaseIcon.vue";

export default defineComponent({
	name: "DjBoxQuote",
	components: {
		DjBox,
		BaseCloudImage,
		BaseIcon,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: false,
		},
		text: {
			type: String,
			default: "",
			required: true,
		},
		author: {
			type: String,
			default: "",
			required: true,
		},
		authorTitle: {
			type: String,
			default: "",
			required: false,
		},
		authorPhotoId: {
			type: String,
			default: "",
			required: false,
		},
	},
});
</script>
